"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = exports.Breadcrumbs = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_aria_components_1 = require("react-aria-components");
var theme_1 = require("../theme");
/**
 * A breadcrumbs component that provides navigation context for the current page.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Breadcrumbs.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-breadcrumbs--default}
 *
 * @example
 * ```tsx
 * <Breadcrumbs>
 *   <Breadcrumb>
 *     <BreadcrumbLink href="/">Home</BreadcrumbLink>
 *   </Breadcrumb>
 *   <Breadcrumb>
 *     <BreadcrumbLink href="/products">Products</BreadcrumbLink>
 *   </Breadcrumb>
 *   <Breadcrumb>
 *     <BreadcrumbLink>Current Item</BreadcrumbLink>
 *   </Breadcrumb>
 * </Breadcrumbs>
 * ```
 *
 * @param children - The contents of the collection. Can be ReactNode or a render function
 * @param isDisabled - Whether the breadcrumbs are disabled
 * @param onAction - Handler that is called when a breadcrumb is clicked
 * @param id - The element's unique identifier
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Breadcrumbs = (0, styled_1.default)(react_aria_components_1.Breadcrumbs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n"])), theme_1.theme.fontSizes.small);
/**
 * A breadcrumb item component that represents a single item in the breadcrumbs navigation.
 *
 * @example
 * ```tsx
 * <Breadcrumb>
 *   <BreadcrumbLink href="/">Home</BreadcrumbLink>
 * </Breadcrumb>
 * ```
 *
 * @param children - The children of the component. Can be ReactNode or a render function
 * @param id - A unique id for the breadcrumb, which will be passed to onAction when the breadcrumb is pressed
 * @param aria-label - Defines a string value that labels the current element
 * @param aria-labelledby - Identifies the element (or elements) that labels the current element
 * @param aria-describedby - Identifies the element (or elements) that describes the object
 * @param aria-details - Identifies the element (or elements) that provide a detailed description
 */
exports.Breadcrumb = (0, styled_1.default)(react_aria_components_1.Breadcrumb)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  :not(:last-child)::after {\n    content: '/';\n    content: '/' / '';\n    alt: ' ';\n    color: ", ";\n    padding: 0 ", ";\n  }\n\n  :has(svg):not(:last-child)::after {\n    font-size: ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  :not(:last-child)::after {\n    content: '/';\n    content: '/' / '';\n    alt: ' ';\n    color: ", ";\n    padding: 0 ", ";\n  }\n\n  :has(svg):not(:last-child)::after {\n    font-size: ", ";\n  }\n"])), theme_1.theme.colors.n600, theme_1.theme.space.space4, theme_1.theme.fontSizes.fontsize24);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Breadcrumbs.js.map